import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConnectorController } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';
import styles from './styles.js';
import { SnackController, RouterController, EventsController } from '@web3modal/core';
let W3mUpdateEmailWalletView = class W3mUpdateEmailWalletView extends LitElement {
  constructor() {
    var _RouterController$sta, _RouterController$sta2;
    super(...arguments);
    this.formRef = createRef();
    this.initialValue = (_RouterController$sta = (_RouterController$sta2 = RouterController.state.data) === null || _RouterController$sta2 === void 0 ? void 0 : _RouterController$sta2.email) !== null && _RouterController$sta !== void 0 ? _RouterController$sta : '';
    this.email = '';
    this.loading = false;
  }
  firstUpdated() {
    var _this$formRef$value;
    (_this$formRef$value = this.formRef.value) === null || _this$formRef$value === void 0 || _this$formRef$value.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        this.onSubmitEmail(event);
      }
    });
  }
  render() {
    const showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialValue;
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-flex flexDirection=\"column\" padding=\"m\" gap=\"m\">\n        <form ", " @submit=", ">\n          <wui-email-input\n            value=", "\n            .disabled=", "\n            @inputChange=", "\n          >\n          </wui-email-input>\n          <input type=\"submit\" hidden />\n        </form>\n\n        <wui-flex gap=\"s\">\n          <wui-button size=\"md\" variant=\"shade\" fullWidth @click=", ">\n            Cancel\n          </wui-button>\n\n          <wui-button\n            size=\"md\"\n            variant=\"fill\"\n            fullWidth\n            @click=", "\n            .disabled=", "\n            .loading=", "\n          >\n            Save\n          </wui-button>\n        </wui-flex>\n      </wui-flex>\n    "])), ref(this.formRef), this.onSubmitEmail.bind(this), this.initialValue, this.loading, this.onEmailInputChange.bind(this), RouterController.goBack, this.onSubmitEmail.bind(this), !showSubmit, this.loading);
  }
  onEmailInputChange(event) {
    this.email = event.detail;
  }
  async onSubmitEmail(event) {
    try {
      if (this.loading) {
        return;
      }
      this.loading = true;
      event.preventDefault();
      const emailConnector = ConnectorController.getEmailConnector();
      if (!emailConnector) {
        throw new Error('w3m-update-email-wallet: Email connector not found');
      }
      await emailConnector.provider.updateEmail({
        email: this.email
      });
      EventsController.sendEvent({
        type: 'track',
        event: 'EMAIL_EDIT'
      });
      RouterController.replace('UpdateEmailWalletWaiting', {
        email: this.email
      });
    } catch (error) {
      SnackController.showError(error);
      this.loading = false;
    }
  }
};
W3mUpdateEmailWalletView.styles = styles;
__decorate([state()], W3mUpdateEmailWalletView.prototype, "email", void 0);
__decorate([state()], W3mUpdateEmailWalletView.prototype, "loading", void 0);
W3mUpdateEmailWalletView = __decorate([customElement('w3m-update-email-wallet-view')], W3mUpdateEmailWalletView);
export { W3mUpdateEmailWalletView };
//# sourceMappingURL=index.js.map